module.exports = __webpack_public_path__ + "img/1-broker-dashboard-copy-13@3x.106e0f51.png";